module.exports = __webpack_public_path__ + "img/3Dian5_7.fe5bda27.png";